import { render } from "./ChatCard.vue?vue&type=template&id=689c4949&scoped=true"
import script from "./ChatCard.vue?vue&type=script&lang=js"
export * from "./ChatCard.vue?vue&type=script&lang=js"

import "./ChatCard.vue?vue&type=style&index=0&id=689c4949&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689c4949"]])

export default __exports__